import React, {ReactElement} from 'react';
import {MapFilters} from '../../../../scenes/MapScene/reducers/filterAndSearchReducer';
import {getWazeIcon} from '../../../../services/WazeIconService';
import AgGrid from '../../../AgGrid';
import {TimeCellRenderer} from '../../../AgGrid/components/DateCellRenderer';
import {MessageAgeCellRenderer} from '../../../AgGrid/components/MessageAgeCellRenderer';
import {FilterSettings} from '../../../AgGrid/Props';
import {Props} from './Props';
import {State} from './State';
import {WazeFeature} from '../../../../interfaces/WazeFeature';
import {handleRowClick} from '../TableService';
import {ICellRendererParams} from '@ag-grid-community/core';

class OverviewAllWazeAlertOther extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            filters: null,
        };
    }

    componentDidMount(): void {
        this.updateGridFilters(this.props.mapFilter);
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        const {mapFilter} = this.props;

        if (mapFilter.filterTimeStamp !== prevProps.mapFilter.filterTimeStamp) {
            this.updateGridFilters(mapFilter);
        }
    }

    render(): ReactElement {
        const {data, showRecordIds, suppressRowClickSelection} = this.props;
        const {filters} = this.state;

        return (
            <AgGrid<WazeFeature>
                columns={[
                    {
                        cellRenderer: (columnData: ICellRendererParams) => {
                            return <img src={`/assets/legend-icons/${getWazeIcon(columnData.value.type, columnData.value.subType)}.svg`} alt="Icoon" />;
                        },
                        valueGetter: (item) => ({type: item.data.properties.type, subType: item.data.properties.subType}),
                        headerName: '',
                        maxWidth: 50,
                        resizable: false,
                    },
                    {
                        valueGetter: (item) => item.data.properties.id,
                        headerName: 'ID',
                        hide: !showRecordIds,
                    },
                    {
                        headerName: 'Locatie',
                        valueGetter: (item) => `${item.data.properties.address || ''} ${item.data.properties.city || ''}`,
                    },
                    {
                        cellRenderer: TimeCellRenderer,
                        valueGetter: (item) => item.data.properties.startedAt,
                        headerName: 'Starttijd',
                        sort: 'desc',
                    },
                    {
                        cellRenderer: MessageAgeCellRenderer,
                        valueGetter: (item) => item.data.properties.startedAt,
                        headerName: 'Duur incident',
                    },
                    {
                        valueGetter: (item) => item.data.properties.confirmedCount || 0,
                        headerName: 'Bevestigingen',
                        maxWidth: 130,
                    },
                    {
                        valueGetter: (item) => item.data.properties.rating,
                        headerName: 'Betrouwbaarheid',
                        maxWidth: 130,
                    }
                ]}
                data={data}
                enableColResize={true}
                enableFilter={true}
                enableSorting={true}
                filters={filters ? filters : undefined}
                rowSelection={'single'}
                suppressScrollOnNewData={true}
                onRowClicked={(item) => handleRowClick(this.props, item)}
                autoRedrawTableColumns={true}
                suppressRowClickSelection={suppressRowClickSelection}
            />
        );
    }

    private readonly updateGridFilters = (mapFilters: MapFilters) => {
        const filters: FilterSettings<WazeFeature> = {
            filters: [],
            identifier: mapFilters.filterTimeStamp,
        };

        if (mapFilters.wazeAlertStatusSet) {
            filters.filters.push({
                field: 'properties.status' as keyof WazeFeature,
                value: ['NONE'],
            });
        }
        if (mapFilters.wazeAlertNdwKnown) {
            filters.filters.push({
                field: 'properties.ndw' as keyof WazeFeature,
                value: ['false'],
            });
        }

        this.setState({
            filters,
        });
    };
}

export default OverviewAllWazeAlertOther;
